"use strict";

var _taggedTemplateLiteral = require("/home/node/workspace/viz-client/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js").default;
var _slicedToArray = require("/home/node/workspace/viz-client/node_modules/@babel/runtime/helpers/slicedToArray.js").default;
var _toConsumableArray = require("/home/node/workspace/viz-client/node_modules/@babel/runtime/helpers/toConsumableArray.js").default;
var _templateObject, _templateObject2;
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AtomPriceLineGradient = exports.AtomPriceLine = void 0;
var react_1 = __importDefault(require("react"));
var d3_1 = require("d3");
var d3fc_discontinuous_scale_1 = require("@d3fc/d3fc-discontinuous-scale");
var styled_components_1 = __importDefault(require("styled-components"));
var luxon_1 = require("luxon");
var hooks_1 = require("../helpers/hooks");
var AtomPriceLine = function AtomPriceLine(_ref) {
  var data = _ref.data,
    xScale = _ref.xScale,
    yScale = _ref.yScale;
  var lineGen = (0, d3_1.line)().defined(function (d) {
    return d.Close !== null;
  }).x(function (d) {
    return xScale(new Date(d.DT));
  }).y(function (d) {
    return yScale(d.Close);
  }).curve(d3_1.curveMonotoneX);
  var path = lineGen(data);
  if (!path) return null;
  return react_1.default.createElement("path", {
    className: 'price-line',
    d: path
  });
};
exports.AtomPriceLine = AtomPriceLine;
var AtomPriceLineGradient = function AtomPriceLineGradient(_ref2) {
  var data = _ref2.data,
    yScale = _ref2.yScale,
    xScale = _ref2.xScale,
    priceDirection = _ref2.priceDirection;
  var closes = data.map(function (d) {
    return d.Close;
  });
  var y0 = priceDirection === 'price-up' ? Math.min.apply(Math, _toConsumableArray(closes)) : Math.max.apply(Math, _toConsumableArray(closes));
  var areaGen = (0, d3_1.area)().x(function (d) {
    return xScale(new Date(d.DT));
  }).y0(yScale(y0)).y1(function (d) {
    return yScale(d.Close);
  }).curve(d3_1.curveMonotoneX);
  var path = areaGen(data);
  if (!path) return null;
  return react_1.default.createElement("path", {
    className: 'area-line',
    d: path,
    fill: "url(#gradient-".concat(priceDirection, ")")
  });
};
exports.AtomPriceLineGradient = AtomPriceLineGradient;
var AtomSparkline = function AtomSparkline(_ref3) {
  var _ref3$resize = _ref3.resize,
    resize = _ref3$resize === void 0 ? 1 : _ref3$resize,
    data = _ref3.data,
    dateDomain = _ref3.dateDomain,
    previousClose = _ref3.previousClose,
    gradient = _ref3.gradient,
    backgroundColor = _ref3.backgroundColor,
    previousCloseColor = _ref3.previousCloseColor;
  var _ref4 = (0, hooks_1.useSVGSize)(),
    _ref5 = _slicedToArray(_ref4, 2),
    svgRef = _ref5[0],
    _ref5$ = _ref5[1],
    width = _ref5$.width,
    height = _ref5$.height;
  var closeData = data.map(function (d) {
    return d.Close;
  }).filter(function (d) {
    return d;
  });
  var yScale = (0, d3_1.scaleLinear)().domain([Math.min.apply(Math, _toConsumableArray(closeData)), Math.max.apply(Math, _toConsumableArray(closeData))]).range([height - 1, 1]) // slight padding so the stroke doesn't get cut off
  .nice();
  var dateData = data.map(function (d) {
    return d.DT;
  });
  var discontinuousScale = (0, d3fc_discontinuous_scale_1.scaleDiscontinuous)((0, d3_1.scaleTime)()).discontinuityProvider((0, d3fc_discontinuous_scale_1.discontinuitySkipWeekends)()).domain(dateDomain // discontinuity scale requires JS dates for the domain and will break on DateTime
  ? dateDomain.map(function (d) {
    return new luxon_1.DateTime(d).toJSDate();
  }) : [new Date(Math.min.apply(Math, _toConsumableArray(dateData))), new Date(Math.max.apply(Math, _toConsumableArray(dateData)))]).range([0, width]);
  var priceDirection = closeData[closeData.length - 1] > (previousClose || closeData[0]) ? 'price-up' : 'price-down';
  return react_1.default.createElement(StyledSVG, {
    ref: svgRef,
    color: priceDirection
  }, resize &&
  // see note about resize above
  data && data.length &&
  // only make visuals when there is data
  width > 0 && height > 0 &&
  // only render if there is svg space
  react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("defs", null, react_1.default.createElement("linearGradient", {
    id: 'gradient-price-up',
    x1: '0',
    x2: '0',
    y1: '0',
    y2: '1'
  }, react_1.default.createElement("stop", {
    offset: '0%',
    stopColor: 'var(--price-up)',
    stopOpacity: '0.1'
  }), react_1.default.createElement("stop", {
    offset: '100%',
    stopColor: backgroundColor || 'transparent'
  })), react_1.default.createElement("linearGradient", {
    id: 'gradient-price-down',
    x1: '0',
    x2: '0',
    y1: '0',
    y2: '1'
  }, react_1.default.createElement("stop", {
    offset: '0%',
    stopColor: backgroundColor || 'transparent'
  }), react_1.default.createElement("stop", {
    offset: '100%',
    stopColor: 'var(--price-down)',
    stopOpacity: '0.1'
  }))), react_1.default.createElement(exports.AtomPriceLine, {
    data: data,
    xScale: discontinuousScale,
    yScale: yScale
  }), gradient && react_1.default.createElement(exports.AtomPriceLineGradient, {
    data: data,
    xScale: discontinuousScale,
    yScale: yScale,
    priceDirection: priceDirection
  }), previousClose && react_1.default.createElement(StyledLine, {
    className: 'previous-close',
    x1: 0,
    x2: width,
    y1: yScale(previousClose),
    y2: yScale(previousClose),
    color: previousCloseColor
  })));
};
var StyledLine = styled_components_1.default.line(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  stroke: ", ";\n"])), function (_ref6) {
  var color = _ref6.color;
  return color;
});
var StyledSVG = styled_components_1.default.svg(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n\n  * {\n    pointer-events: none;\n  }\n\n  .price-line {\n    fill: none;\n    stroke: var(--", ");\n    stroke-width: 2;\n  }\n\n  .previous-close {\n    fill: none;\n    stroke-dasharray: 4;\n  }\n"])), function (_ref7) {
  var color = _ref7.color;
  return color;
});
exports.default = AtomSparkline;